import { Elements } from '@stripe/react-stripe-js';
import { Appearance, loadStripe } from '@stripe/stripe-js';
import { FunctionComponent as FC, useMemo } from 'react';
import { colors } from '../../../styles/theme';

interface StripeWrapperProps {
  apiKey: string;
  children: any;
  clientSecret: string;
}

export const StripeWrapper: FC<StripeWrapperProps> = ({
  apiKey,
  children,
  clientSecret,
}: StripeWrapperProps) => {
  const stripePromise = useMemo(() => {
    return loadStripe(apiKey);
  }, [apiKey]);

  const appearance: Appearance = {
    variables: {
      colorPrimary: colors.tIndigo.base,
      // colorBackground: 'red',
      colorText: colors.tPurple.base,
      colorDanger: colors.tRed.base,
      fontFamily: `"Roboto", sans-serif`,
      spacingUnit: '2px',
      borderRadius: '2px',
    },
    rules: {
      '.Label': {
        fontWeight: '600',
        marginBottom: '8px',
        marginTop: '16px',
      },
      '.Input': {
        borderColor: colors.tGray.lightPurple,
      },
      '.Input--invalid': {
        borderWidth: '1px',
      },
      '.Error': {
        marginTop: '4px',
      },
    },
  };

  return (
    <Elements
      stripe={stripePromise}
      options={{
        clientSecret,
        appearance,
      }}
    >
      {children}
    </Elements>
  );
};
